import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class ConnectivityService {
  private readonly online$ = new BehaviorSubject<boolean>(
    typeof navigator !== 'undefined' ? navigator.onLine : true,
  );

  
  readonly isOnline$ = this.online$.asObservable();

  constructor() {
    if (typeof window === 'undefined') {
      return;
    }
    
    
    window.addEventListener('online', () => this.online$.next(true));
    window.addEventListener('offline', () => this.online$.next(false));
  }

  get isOnline(): boolean {
    return this.online$.value;
  }
}
